import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component } from '@angular/core';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { FamilyService } from '@app/services/family/family.service';
import { MenuService } from '@app/services/menu/menu.service';
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    moduleId: module.id,
    selector: 'carte-menus',
    templateUrl: 'carte-menus.component.html',
    styleUrls: ['carte-menus.component.scss']
})
export class CarteMenusComponent {
    menucategories: any[] = [];
    menucategorie: any = {};
    menus: any[] = [];
    chosenOrderType: number;
    bsModalRef: BsModalRef;
    subscriptions2: Subscription[] = [];
    loadMenus = true;
    nbrOffersAuthorizedSite: number;
    offerNbr: number;
    orderProg;
    orderType;
    constructor(
        private familyService: FamilyService,
        private route: ActivatedRoute,
        private menuService: MenuService,
        private orderService: OrdersService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private pdvService: PdvService,
        private router: Router,
    ) {
        let subs5 = this.orderService.orderType.subscribe((orderType: number) => {
            this.orderType = orderType;
        });
        const subs1 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs2 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getElements();
        });
        const subs3 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        const subs4 = this.orderService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        this.subscriptions2.push(subs1, subs2, subs3, subs4,subs5);
    }

    getElements(){
        if (this.menucategories.length == 0) {
            this.familyService.menucategories.subscribe(
                (menucategories: any[]) => {
                    if (menucategories.length > 0) {
                        this.menucategories = menucategories
                        this.route.params.subscribe(params => {
                            if (params['menu']) {
                                let index = this.menucategories.findIndex(f => f.slug == params['menu']);
                                if(index>-1){
                                    this.menucategorie = this.menucategories[index];
                                    this.getMenus();
                                }else{
                                    this.router.navigate(["/modes"]);
                                }
                            }
                        })
                    }
                })
        } else {
            this.getMenus();
        }
    }

    getMenus() {
        this.loadMenus = true;
        this.menuService.getMenusOfCategory(this.menucategorie.id, this.orderType, this.orderProg).toPromise().then(
            (menus: any[]) => {
                this.menus = menus;
                this.loadMenus = false;
            }
        )
    }

    ngOnInit() {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.menus = [];
                this.loadMenus = true;
            }
        })
    }

    OpenMenuModal(i) {
        if (this.chosenOrderType > 0) {
            if (this.menus[i].offer == null || (this.menus[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3' });
                this.bsModalRef.content.menu = this.menus[i];
            } else {
                this.toastr.error('', 'Vous avez atteint le nombre d\'offre autorisée');
            }
        } else {
            console.log(this.menucategorie);
            this.router.navigate(["/modes"], { queryParams: {menu:this.menucategorie.slug} });
        }
    }


    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }

}
